import { FC } from 'react';

import { s } from 'utilities/strings';

const SearchInput: FC = () => {
  return (
    <input
      className="form-control"
      placeholder={s('Site.Search', { suffix: '...' })}
      type="text"
    />
  );
};

export default SearchInput;
